import React from "react";
import { Field } from "redux-form";

const format = value => {
  if (!value) {
    return "";
  }

  return value.replace(/[^\w]|_/g, "").slice(0, 5);
};

export default function CageField(props) {
  const { ...rest } = props;

  return <Field type="text" format={format} {...rest} />;
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/CageField/CageField.jsx